import { CloseOutlined } from "@ant-design/icons";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { Button, Form, Modal } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { ISelectOption } from "../../../../../../api/selectOptions/selectOptionsApi";
import { NodataTable } from "../../../../../../components/NoDataTable";
import useLoading from "../../../../../../hook/useLoading";
import useToast from "../../../../../../hook/useToast";
import { selectorInfoUser } from "../../../../../../store/slices/infoUserSlice";
import { selectorUnitByUserPermission } from "../../../../../../store/slices/UnitByUserPermission";
import '../../../../styles.scss';
import { IQuestionSurvey } from "../../../../../../api/Customer_V2/customerApi_V2";

interface SurveyRow {
    stt: number;
    question: string;
    answer: string;
    reason?: string;
}
const textCellStyle = {
    whiteSpace: 'normal',
    lineHeight: '1.6',
    display: 'flex',
    alignItems: 'center',
}

const rowData: SurveyRow[] = [
    {
        stt: 1,
        question:
            "Câu 1: Từ khi giao xe đến giờ, xe mình vận chạy tốt chứ ah? Anh chị có nhận xét gì về CL sản phẩm không?",
        answer: "Có",
        reason: "Không xác định",
    },
    {
        stt: 2,
        question:
            "Câu 2: TVBH có giao xe đúng thời gian cam kết khi ký hợp đồng với anh/chị không ah?",
        answer: "Không",
        reason: "Không đúng hẹn",
    },
    {
        stt: 3,
        question:
            "Câu 3: Anh/chị có được hướng dẫn sử dụng xe đầy đủ và giải thích về chính sách bảo hành không? Anh/chị có được hướng dẫn sử dụng xe đầy đủ và giải thích về chính sách bảo hành không? Anh/chị có được hướng dẫn sử dụng xe đầy đủ và giải thích về chính sách bảo hành không?",
        answer: "Không",
        reason: "Giao xe tại địa điểm khác",
    },
    {
        stt: 4,
        question:
            "Câu 4: Anh/chị có được bàn giao đầy đủ các hồ sơ, phụ kiện khi nhận xe không ah?",
        answer: "Có",
        reason: "Không xác định",
    },
    {
        stt: 5,
        question:
            "Câu 5: Ngoài ra anh/chị có thêm ý kiến đóng góp gì không?",
        answer: "Không",
        reason: "Ký HĐ (giải thích các điều khoản HĐ)",
    },
];

interface ModalProps {
    isOpen: boolean
    infoQuestionSurvey: IQuestionSurvey[]

    closeModal: (isOpen: boolean) => void
}
const ModalSurveyInformationDetail: React.FC<ModalProps> = ({
    isOpen, infoQuestionSurvey,
    closeModal
}) => {

    const columnDefs: ColDef<IQuestionSurvey>[] = [
        {
            headerName: "STT",
            width: 60,
            sortable: false,
            valueGetter: (params) => {
                return params.node ? params.node.rowIndex! + 1 : '';
            },
            cellStyle: {
                textAlign: "center",
                fontWeight: 500,
            },
        },
        {
            headerName: "Câu hỏi khảo sát",
            field: "questionContent",
            flex: 1,
            wrapText: true,
            autoHeight: true,

            cellStyle: textCellStyle,
        },
        {
            headerName: "Câu trả lời",
            field: "answerContent",
            wrapText: true,
            autoHeight: true,
            width: 150,
            cellStyle: textCellStyle,
        },
        {
            headerName: "Lý do (nếu có)",
            field: "reason",
            width: 150,
            wrapText: true,
            autoHeight: true,

            cellStyle: textCellStyle,
        },
    ];


    return (
        <Modal
            title={<div className="bg-FCFCFD d-flex justify-betweeen align-center pb-4  w-full border-b-F0F0F0 rounded-2 overflow-hidden">
                <span className="text-base text-344054 fw-500 font-medium">Xem chi tiết câu hỏi khảo sát</span>
                <CloseOutlined className="text-base text-8B8B8B" onClick={() => closeModal(false)} />
            </div>}
            open={isOpen}
            onCancel={() => closeModal(false)}
            centered
            className=" custom-modal-ant-history"
            destroyOnClose
            closeIcon={false}
            footer={<div className="bg-FCFCFD d-flex justify-betweeen align-center pt-2  w-full border-t-F0F0F0">
                <div className="custom-page-css w-full flex justify-end gap-2 mt-4">
                    <Button
                        onClick={() => closeModal(false)}
                    >
                        Huỷ
                    </Button>
                </div>
            </div>}
        >
            <div className="custom-modal-ant-history-child custom-page-css flex flex-col max-h-65vh overflow-y-scroll gap-2 py-2">
                <div className="ag-theme-alpine custom-table-ag custom-css-table modal" style={{ width: '100%', height: 610 }}>
                    <AgGridReact
                        className="my-auto-height-grid"
                        getRowStyle={(params: any) => ({
                            backgroundColor: params?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                        })}
                        rowData={infoQuestionSurvey}
                        columnDefs={columnDefs}
                        // rowHeight={55}
                        overlayNoRowsTemplate={NodataTable}
                        // onGridReady={(params) => {
                        //     params.api.sizeColumnsToFit();
                        // }}


                        /* Selection – CHỈ CHO PHÉP SELECT BẰNG CODE */
                        rowSelection="single"
                        suppressRowClickSelection={true}

                        /* Performance */
                        suppressColumnVirtualisation={true}
                        suppressRowVirtualisation={true}
                        enableCellTextSelection={true}
                        ensureDomOrder={true}
                        debounceVerticalScrollbar={true}
                        suppressScrollOnNewData={true}
                        suppressDragLeaveHidesColumns={true}

                        /* Scroll */
                        rowBuffer={20}
                        maxBlocksInCache={10}
                        infiniteInitialRowCount={1000}
                    />


                </div>


            </div>
        </Modal>
    )
}
export default ModalSurveyInformationDetail
